import ProjectTabs from '@/components/ProjectTabs/ProjectTabs';
import './Project.less';
import { useEffect, useState } from 'react';
import projectIcon from '@/assets/home/modelImg.png';
import { Input, Modal, Pagination, Popover, Spin, Upload } from 'antd';
import { useNavigate } from 'react-router-dom';
import { SDService, projectController } from '@/api';
import GLBViewer from '@/components/GLBViewer/GLBViewer';
import Uploader from '@/utils/uppyUpload';
import { formatDateTime, timeDiffFromNow } from '@/utils/dayjs';
import toast from 'react-hot-toast';
import { decrypted } from '@/utils/crypto';
import { info } from '@/utils/message';
import closeIcon from '@/assets/project/closewhite.png';
import { useTranslation } from 'react-i18next';

export default function Home() {
  const [list, setList] = useState([]);
  const [pageSize, setPageSize] = useState(12);
  const [showEditProject, setShowEditProject] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [type, setType] = useState(0);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [showPopMenuId, setShowPopMenuId] = useState(null);

  const [project, setProject] = useState(null);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const [projectName, setProjectName] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    query();
  }, [page, type]);

  const query = async () => {
    setLoading(true);
    setList([]);
    const res = await projectController.list({
      pageIndex: page,
      pageSize: pageSize,
      type: type == 0 ? 1 : type == 1 ? 0 : type,
    });
    if (res.code == 0) {
      setLoading(false);
      setTotal(res.data.totalRow);
      setList(res.data.records);
    }
  };

  const clickProject = (item) => {
    if (item.state === 0) {
      info(t('app.generating'));
    } else if (item.state === 1) {
      navigate('/preview/' + item.id);
    } else if (item.state === 2) {
      window.location.href =
        window.location.protocol + '//' + window.location.host + '/texture/' + item.id;
    }
  };

  const cancelEdit = () => {
    setShowEditProject(false);
    setProjectName('');
  };

  const confirmEdit = async () => {
    if (projectName && projectName.trim() && !saveLoading) {
      setSaveLoading(true);
      const res = await projectController.editName(project.id, projectName);
      setSaveLoading(false);
      cancelEdit();
      query();
    }
  };

  const deleteProject = async (project) => {
    const res = await projectController.deleteProject(project.id);
    cancelEdit();
    if ((page - 1) * pageSize + 1 === total && total != 1) {
      setPage(1);
    } else {
      query();
    }
  };

  const download = (project) => {
    if (project.state === 0) {
      info('Generating...');
      return;
    }
    if (project.meshUrl) {
      const url = project.meshUrl;
      const a = document.createElement('a');
      a.href = url;
      a.download = 'model.glb';
      a.click();
    }
  };

  const collect = async (project) => {
    await projectController.collect(project.id);
    query();
  };

  const editPro = (project) => {
    setShowEditProject(true);
    setProject(project);
    setProjectName(project.name);
  };

  return (
    <div className="project-home">
      <div className="project">{t('app.project')}</div>
      <ProjectTabs
        tabs={[t('app.generate3dProject'), t('app.generateTexture'), t('app.favorites')]}
        onChange={(item, i) => {
          if (type != i) {
            setPage(1);
          }
          setType(i);
        }}></ProjectTabs>
      <Spin style={{ backgroundColor: 'rgb(27,27,27)', marginTop: 20 }} spinning={loading}></Spin>
      <div className="list">
        {list.map((item) => {
          return (
            <div key={item.id} className="item" onClick={() => {}}>
              <div className="project-img-wrapper">
                {item.cover ? (
                  <img className="project-img" src={item.cover}></img>
                ) : (
                  <img className="project-img project-default-img" src={projectIcon}></img>
                )}

                <div
                  className="hover-wrapper"
                  onClick={(event) => {
                    // event.stopPropagation();
                  }}>
                  <div
                    className="edit-pen"
                    onClick={(event) => {
                      clickProject(item);
                      // event.stopPropagation();
                      // editPro(item);
                    }}></div>
                  <div
                    className={'heart ' + (item.hasCollected ? 'hearted' : '')}
                    onClick={() => {
                      collect(item);
                    }}></div>
                </div>
              </div>
              <div className="names">
                <div className="left">
                  <div className="name">{item.name}</div>
                  <span className="modified-time">
                    {t('app.lastUpdated')} {timeDiffFromNow(item.gmtModified)}
                  </span>
                </div>
                <Popover
                  arrow={false}
                  trigger="click"
                  open={showPopMenuId === item.id}
                  color="#222222"
                  placement="leftTop"
                  onOpenChange={(value) => {
                    if (value) {
                      setShowPopMenuId(item.id);
                    } else {
                      setShowPopMenuId(null);
                    }
                  }}
                  content={
                    <div className="project-drop-select" onClick={() => {}}>
                      <div
                        className="drop-select-item"
                        onClick={(event) => {
                          setShowPopMenuId(null);
                          event.stopPropagation();
                          download(item);
                        }}>
                        <div className="download-icon"></div>
                        <div className="drop-select-item-name">{t('app.download')}</div>
                      </div>
                      <div
                        className="drop-select-item"
                        onClick={(event) => {
                          setShowPopMenuId(null);
                          event.stopPropagation();
                          editPro(item);
                        }}>
                        <div className="rename-icon"></div>
                        <div className="drop-select-item-name">{t('app.rename')}</div>
                      </div>
                      <div
                        className="drop-select-item"
                        onClick={(event) => {
                          setShowPopMenuId(null);
                          event.stopPropagation();
                          deleteProject(item);
                        }}>
                        <div className="delete-icon"></div>
                        <div className="drop-select-item-name">{t('app.delete')}</div>
                      </div>
                    </div>
                  }>
                  <div
                    className="right"
                    // onMouseEnter={() => {
                    //   setShowPopMenuId(item.id);
                    // }}
                    // onMouseLeave={() => {
                    //   setShowPopMenuId(null);
                    // }}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}></div>
                </Popover>
              </div>
            </div>
          );
        })}
      </div>
      {!loading && (
        <div className="page">
          <Pagination
            showSizeChanger={false}
            onChange={(val) => {
              setPage(val);
            }}
            current={page}
            pageSize={pageSize}
            defaultCurrent={1}
            total={total}
          />
        </div>
      )}

      {showEditProject && (
        <Modal
          open={showEditProject}
          closeIcon={<img className={'modal-close-icon'} src={closeIcon}></img>}
          wrapClassName="custom-modal"
          onCancel={() => {
            setShowEditProject(false);
          }}
          footer={<></>}>
          <div
            className="edit-project-content"
            onClick={(e) => {
              e.stopPropagation();
            }}>
            <div className="title">{t('app.renameProject')}</div>
            <Input
              className="input"
              value={projectName}
              maxLength={128}
              onClick={(e) => {
                e.stopPropagation();
              }}
              onChange={(e) => {
                setProjectName(e.target.value);
              }}></Input>
            <div className="btns">
              <div
                className="cancel-btn"
                onClick={() => {
                  cancelEdit();
                }}>
                {t('app.cancel')}
              </div>
              <div
                className="ok-btn"
                onClick={() => {
                  confirmEdit();
                }}>
                {saveLoading && <div className={'loading'}></div>}
                {t('app.ok')}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
